import { BrowserRouter as Router } from 'react-router'
import { I18nextProvider } from 'react-i18next'
import { AuthProvider, Authenticated, Unauthenticated, AuthLoading } from '@agion/auth'
import type { AuthConfig } from '@agion/auth'
import { Spinner } from '@agion/ui'
import { AppRouter } from './router/analytics_router'
import i18n from './core/analytics_i18n'
import { getConfig } from './core/analytics_runtime_env'

const authConfig: AuthConfig = {
  authUrl: getConfig('VITE_AUTH_URL', 'http://localhost:8080') ?? 'http://localhost:8080',
  apiUrl: getConfig('VITE_API_URL', 'http://localhost:8090') ?? 'http://localhost:8090',
  loginUrl: getConfig('VITE_LOGIN_URL', 'http://localhost:3000') ?? 'http://localhost:3000',
  appName: 'analytics-ui',
  mockAuth: getConfig('VITE_MOCK_AUTH') === 'true',
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider config={authConfig}>
        <AuthLoading>
          <div className="flex h-screen items-center justify-center">
            <Spinner size="lg" />
          </div>
        </AuthLoading>
        <Authenticated>
          <Router>
            <AppRouter />
          </Router>
        </Authenticated>
        <Unauthenticated>
          <RedirectToLogin />
        </Unauthenticated>
      </AuthProvider>
    </I18nextProvider>
  )
}

function RedirectToLogin() {
  const loginUrl = getConfig('VITE_LOGIN_URL', 'http://localhost:3000') ?? 'http://localhost:3000'
  window.location.href = `${loginUrl}?app=analytics-ui&return_to=${encodeURIComponent(window.location.href)}`
  return null
}

export default App
